/*
This list of address are from owner who held BOTH
Anchor Certificates: https://etherscan.io/address/0x600a4446094c341693c415e6743567b9bfc8a4a8
Paintings of Forgotten Souls: https://etherscan.io/address/0x6dae8a922b66225de1728bd9e5f2b7a4bdd4699b
Logged Universe Little Martians: https://etherscan.io/address/0xaBFfa842C2E03446AD0cACAdf9570bf1a45E2432

*/

// This list is derived through using:
// https://dune.xyz/queries/499576 (overlap snapshot tool)
// Pasting array into sheet.
// Copying to https://arraythis.com/


// Generated at block: 15618002
// Last generated on 2022-09-26 10:00 EST
const overlap = ['0x202eca424a8db90924a4daa3e6bcecd9311f668e', '0xc3de4f9c763ec015deb165d0a96fbafa390286bc', '0x0cacc6104d8cd9d7b2850b4f35c65c1ecdeece03', '0x68a7ac13477aad590982293feeeb786a00276cf2', '0x13ebd3443fa5575f0eb173e323d8419f7452cfb1', '0x292d76ef68931cda7c2fb2b580df263dca3d9b9b', '0xab876791757b47d202b7d6def038940ce7a64fe4', '0xae3a3d0a97fa75a340cc879700939699d775688c', '0xd23ae11f017fe6db1aa74dd0138c2bff3b245bb6', '0xeefbada5539f9ae2c87c1151cdb2057398383342', '0x002936cd9bcb36cd2b5f168edb16dc983afcc1c3', '0xf7425fb026f9297fcc57b14ace187215442586a2', '0x1c051112075feaee33bcdbe0984c2bb0db53cf47', '0x2e44f49552c0c8e93f60318520760f619c03615f', '0x317bc38b66566566529c41462ba774f489b4a63f', '0x4799b18582cbb51cc207ed9716034da309edf47e', '0x8ce9ec296542ec95c0259572f1c8965c30cd7df0', '0x9cbbcd3b4129b1c00f0cd851baf118ebb0c4f168', '0xaf69610ea9ddc95883f97a6a3171d52165b69b03', '0xdbf14da8949d157b57acb79f6eee62412b210900'];

module.exports = overlap
  